/**
 * Action Typesを定義
 */
const GISTTPTL01ActionType = {
    GET_WORK_PLAN_CASE_LIST_REQUEST: 'GET_WORK_PLAN_CASE_LIST_REQUEST',         // 作業計画案件一覧取得定義
    GET_WORK_PLAN_CASE_LIST_SUCCESS: 'GET_WORK_PLAN_CASE_LIST_SUCCESS',         // 作業計画案件一覧取得成功定義
    GET_WORK_PLAN_CASE_LIST_FAILURE: 'GET_WORK_PLAN_CASE_LIST_FAILURE',         // 作業計画案件一覧取得失敗定義
    GET_WORK_PLAN_CASE_LIST_RESET: 'GET_WORK_PLAN_CASE_LIST_RESET',             // 作業計画案件一覧取得リセット定義
};

export default GISTTPTL01ActionType;
